export default __webpack_public_path__ + "static/crowdStrike-4309f74b3042ccfe72f4ad2d878bcca2.png";